;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	const Collection = APP.module('Collection');
	const Model = APP.module('Model');

	Collection.SubMenuItems = Collection.MenuItems.extend({
		initialize: function(){
			this.add([
				{path: "account", name: 'My Account'},
				{path: "logout", name: 'Log Out'}
			]);
		}
	});

}(window, APP, Backbone, Marionette, $, _));
